import { toSatang } from './roundingAmount';

// total_pay_amount belongs to this invoice; transfer_amount belongs to the upload.
export const invoicePaymentAmount = (row) => row.total_pay_amount ?? '';
export const invoiceTxnSatang = (row) =>
  toSatang(invoicePaymentAmount(row)) - toSatang(row.fee);
export const invoiceTxnAmount = (row) => invoiceTxnSatang(row) / 100;
export const selectedTxnAmount = (rows) =>
  rows.reduce((total, row) => total + invoiceTxnSatang(row), 0) / 100;
